import exportLang from './export'

export default {
    'export': exportLang
}